<template>
	<section class="gray-bg">
		<div class="container">
		
			<div class="row" data-aos="fade-up">
				<div class="col-md-12">
					<div class="heading">
						<h2>{{ $t('about.clients') }}</h2>
					</div>
				</div>
			</div>
			<div class="row" data-aos="fade-up">
				<div class="employer-slide">
					<div class="employer-widget" v-for="c in clients">
						<div class="u-content">
							<div class="avatar box-80">
								<a :href="c.url" target="_blank"><img class="img-responsive" :src="STATIC_URL + c.thumb" alt=""></a>
							</div>
							<h5><a :href="'http://' + c.url" target="_blank">{{ $i18n.locale === 'zh' ? c.c_name : c.e_name }}</a></h5>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
  name: 'Client',
  data: () => ({
    clients: [
    ]
  }),
  mounted: function() {
    let that = this
	  this.$http.get(this.API3_PREFIX + 'clients').then(function (response) {
		that.clients = response.data
		that.$nextTick(() => {
			$('.employer-slide').slick({
			  centerMode: true,
			  centerPadding: '0px',
			  slidesToShow: 4,
			  responsive: [
				{
				  breakpoint: 768,
				  settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '0px',
					slidesToShow: 3
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '0px',
					slidesToShow: 1
				  }
				}
			  ]
		    })
		})
      }).catch(function (error) {
		console.log(error)
      })
  }
}
</script>